import axiosService from "./AxiosService.js";

const critsToQs = (criteres) => {
  let result = "";
  let crits = Object.keys(criteres);
  console.log("crits", crits);
  result = crits
    .map((critCode) =>
      criteres[critCode].map((valeur) => critCode + "=" + valeur.id).join("&")
    )
    .join("&");
  console.log("result", result);
  return result;
  //criteres.flatMap((crit) => crit.code + "=" + crit.valeur);
};

const multiCritsService = {
  getCriteresPossibles() {
    return axiosService.get(`/rechercher/criteres`);
  },
  getValeurs(type, extrait, autresCriteres) {
    let url = `/rechercher/valeurs?c=${type}&e=${extrait}`;
    if (autresCriteres) {
      let criteres = {};
      for (let key in autresCriteres) {
        if (key != type) {
          criteres[key] = autresCriteres[key];
        }
      }
      let urlComp = critsToQs(criteres);
      url += `&${urlComp}`;
    }
    return axiosService.get(url);
  },
  getProduits(criteres, page = null) {
    if (criteres) {
      let qs = critsToQs(criteres);
      return axiosService.get(
        `/rechercher/produits?${qs}${page ? "&pageIndex=" + page : ""}`
      );
    } else {
      return axiosService.get(`/rechercher/produits`);
    }
  },
};
export default multiCritsService;
